<template>
  <v-card>
    <v-card-title>{{ $t("categories.title") }}</v-card-title>
    <v-card-text>
        <Exporter :data="this.items" :headers="headers" filename="categories.csv" />
        <v-data-table
            :headers="headers"
            :items="this.items"
            must-sort hide-default-headers disable-pagination hide-default-footer>
        <template v-slot:item.applicationType="{item}">
          {{ applicationType(item.applicationType) }}
        </template>
        <template v-slot:item.remove="{item}">
          <v-btn icon small color="red" @click="remove(item.id)"><v-icon>delete</v-icon></v-btn>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="showDialog()" color="success">
        {{ $t("ctrl.add") }}
      </v-btn>
      <v-btn @click="getReport()" color="warning">
        Report
      </v-btn>
    </v-card-actions>
    <CompetitionCategory ref="dialog" :reload="this.reload" />
  </v-card>
</template>

<script>
  import {
    VCard,
    VTooltip,
    VForm,
    VTextField,
    VCardActions,
    VCardText,
    VSelect,
    VDataTable,
    VDatePicker,
  } from 'vuetify/lib'
  import CompetitionCategory from '../../dialogs/CompetitionCategory.vue'
  import fccapi from '../../fccapi'
  import Exporter from '../Exporter.vue'

  export default {
    name: 'FCCCompetitionCategories',
    data: function(){
        return {
            items: []
        }
    },
    computed: {
      genders: function () { 
        return [this.$t("profile.male"), this.$t("profile.female")]
      },
      selectedCompetition: function() {
            return this.$store.getters['competitionId'];
        },
      headers: function(){
        return [
            { text: this.$t("categories.order"), value: "order"},
            { text: this.$t("categories.label"), value: "label"},
            { text: this.$t("application.type"), value: "applicationType"},
            { text: this.$t("categories.name"), value: "name"},
            { text: '', value: 'remove' }
        ]
      }
    },
    methods: {
        applicationType: function(i) {
            return this.$t('application.'+Array('individual', 'tandem', 'relay')[i]);
        },
        showDialog: function(){
          this.$refs.dialog.show();
        },
        reload: function(){
          fccapi.competitionGet("categories").then(d=>{
            this.items = d.data;
          })
        },
        remove: function(id){
          fccapi.delete(`categories/${id}`).then(d => {
            this.reload();
          })
        },
        getReport: function(){
          fccapi.competitionGet('categories/report').then(d => {
            alert(JSON.stringify(d.data));
          })
        }
    },
    mounted: function(){
        this.reload();
    },
    watch: {
        selectedCompetition() {
            console.log("changed")
            this.reload();
        }
    },
    components: {
        VCard,
        VTooltip,
        VForm,
        VTextField,
        VCardActions,
        VCardText,
        VSelect,
        VDataTable,
        VDatePicker,
        CompetitionCategory,
        Exporter
    },  
  }
</script>